<template>
  <div class="body-container seven-theme d-flex">
    <div class="content">
      <seven-header-child
        :classic="true"
        :changeName="changeName"
        :currentLang="currentLang"
        :newItem="newItem"
        :restaurant="restaurant ? restaurant : {}"
      />
      <seven-body-child
        :classic="true"
        :log="log"
        :functionCollapsed="functionCollapsed"
        :newSection="newSection"
        :newItem="newItem"
        :listSections="listSections"
        :restaurant="restaurant ? restaurant : {}"
        :currentTab="currentTab"
        :setCurrentTab="setCurrentTab"
        :changeSectionTitle="changeSectionTitle"
        :changeSectionSubTitle="changeSectionSubTitle"
        :addItem="addItem"
        :newSubSection="newSubSection"
        :handleChangeShowSub="handleChangeShowSub"
        :disponibleItem="disponibleItem"
        :showItem="showItem"
        :changeItemObservation="changeItemObservation"
        :changeItemTitle="changeItemTitle"
        :changeItemPrice="changeItemPrice"
        :editCategorie="editCategorie"
        :deleteSection="deleteSection"
        :editSubCategorie="editSubCategorie"
        :deleteSubSection="deleteSubSection"
        :editItem="editItem"
        :currentCurrency="currentCurrency"
        :deleteItem="deleteItem"
        :addToCart="addToCart"
      />
      <seven-footer-child
        :currentLang="currentLang"
        :newItem="newItem"
        :restaurant="restaurant ? restaurant : {}"
      />
    </div>
    <div style="position: relative; flex:1; display:flex;display:none;">
      <div class="web_detail"></div>
      <div class="right-seven">
        <img
          :src="
            ` ${
              restaurant.logo
                ? 'htttp://localhost:3333/logos/' + restaurant.logo
                : 'htttp://localhost:3333/logos/logo.png'
            } `
          "
          alt=""
          class="logo-right-seven"
        />
        <p class="restauName_seven">
          {{ restaurant.name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import sevenHeader1 from "../headers/seven-header.vue";
import sevenBody1 from "../body/seven-body.vue";
import footerSecond1 from "../footer/footer-second.vue";

export default {
  components: {
    "seven-header-child": sevenHeader1,
    "seven-body-child": sevenBody1,
    "seven-footer-child": footerSecond1,
  },
  props: [
    "changeName",
    "currentLang",
    "newItem",
    "restaurant",
    "log",
    "functionCollapsed",
    "newSection",
    "listSections",
    "currentTab",
    "setCurrentTab",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "addItem",
    "newSubSection",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "changeItemObservation",
    "changeItemTitle",
    "changeItemPrice",
    "editCategorie",
    "deleteSection",
    "editSubCategorie",
    "deleteSubSection",
    "editItem",
    "currentCurrency",
    "deleteItem",
    "addToCart",
  ],
  data() {
    return {};
  },
  methods: {},
  watch: {},
};
</script>

<style>
@import url("../styles/sevenTheme/theme.css");
</style>
